export { default as now } from './now.js';
export { default } from './date.default.js';



//////////////////
// WEBPACK FOOTER
// ./node_modules/lodash-es/date.js
// module id = 1264
// module chunks = 0